import React, { FunctionComponent } from 'react'
import { Badge } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCollapse } from 'Redux/selectors/sidebar'
import { useTranslation } from 'react-i18next'

import { SidebarLinkProps } from './SidebarLinkProps'

import {
  SidebarLinkItem,
  SidebarLinkText,
  SidebarIconBlock,
  NewLabel,
} from './styles'

const SidebarLink: FunctionComponent<SidebarLinkProps> = ({
  title,
  icon,
  route,
  onClick,
  reviewsLength,
  balance,
  rank,
  isNew,
}) => {
  const { t } = useTranslation()
  const collapse: boolean = useSelector(getCollapse)

  const setBadge = () => {
    if (reviewsLength) {
      return (
        <Badge className="sidebar__link-badge">
          <span>{reviewsLength}</span>
        </Badge>
      )
    }
    if (balance) {
      return <span>${balance}</span>
    }
    if (rank) {
      return (
        <Badge className="sidebar__link-badge" color="success">
          <span>{rank.toLocaleString()}</span>
        </Badge>
      )
    }
    return null
  }

  return (
    <NavLink
      to={route}
      activeClassName="sidebar__link-active"
      onClick={onClick}
    >
      <SidebarLinkItem collapse={collapse}>
        <SidebarIconBlock>{icon}</SidebarIconBlock>
        {!collapse ? (
          <SidebarLinkText>
            {title}
            {isNew && <NewLabel>{t('sidebar.new')}</NewLabel>}
          </SidebarLinkText>
        ) : (
          <SidebarLinkText />
        )}
        {!collapse ? setBadge() : null}
      </SidebarLinkItem>
    </NavLink>
  )
}

export default SidebarLink
